// NOTE: This file is maintained in the parent project AS Common.
//       Your application should avoid modifying this file.

import { AppRoot } from "AppRoot";
// APP SPECIFIC: Bundle detection and per-bundle auth provider selection
import { AppProvider } from "app/appService";
import { AuthProviderSelector } from "app/AuthProviderSelector";
import { setupAxios } from "common";
import "common/i18n";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";

setupAxios();

const container = document.getElementById("root");
const root = createRoot(container);
const isTestEnvironment =
  import.meta.env.DEV && import.meta.env.VITE_ENVIRONMENT === "test";

// APP SPECIFIC: AppProvider wraps the app, and AuthProviderSelector replaces AuthProvider
root.render(
  <AppProvider>
    {isTestEnvironment ? (
      <AppRoot />
    ) : (
      // <React.StrictMode>
      <AuthProviderSelector>
        <AppRoot />
      </AuthProviderSelector>
      // </React.StrictMode>
    )}
  </AppProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
